const conf = {
  networks: {
    10143: {
      token: "MON",
      chainId: "0x279f",
      chainName: "Monad Testnet",
      token_list: {
        PT: "0x22B610a109F5eD204D5D25e186940cb722054988"
      },
      factory_address: "0x0188b5b4D6869a706c153b89B7142Dd4879B6CA1",
    },
    11155111: {
      token: "ETH",
      chainId: "0xaa36a7",
      chainName: "Sepolia",
      token_list: {
        PTT: "0x7B07C3a14193c9bB99598627E881F24adf8186eF"
      },
      factory_address: "0x68335032d9Bd27b43fD05D21275345235A1096dD",
    }
  },
};

export default conf;
